angular.module('app').component('owCards', {
    templateUrl: 'js/components/ow-cards/index.html',
    require: {
        $ow: '^^objectWindow',
    },
    controller: OWCardsController,
    controllerAs: '$dc',
});

OWCardsController.$inject = ['$scope', '$http', '$q', '$translate', '$ngConfirm', 'toaster'];

function OWCardsController($scope, $http, $q, $translate, $ngConfirm, toaster) {
    var $ctrl = this;
    $ctrl.drivers = false;

    var cache = {};
    var alertsCache = {};

    $ctrl.cards = [];
    $ctrl.alerts = [];

    $ctrl.expands = {
        cards: false,
    };

    $ctrl.toggleExpand = function(key) {
        $ctrl.expands[key] = !$ctrl.expands[key];

        if (!(key === 'cards' && $ctrl.expands[key] === true)) {
            $ctrl.$ow.api.on.resize();
            return false;
        }

        for (var i = 0; i < $ctrl.cards.length; i++) {
            var card = $ctrl.cards[i];

            if (card.type === 'tachograph') {
                loadDailyAnalyse(card.state.ObjectId, card.state.Value).then(function(response) {
                    card.analyze = response.analyze;
                    $ctrl.$ow.api.on.resize();
                });
            }
        }
    };

    var reload = function(force) {
        if (!$ctrl.$ow.isOWCardsAvailable()) {
            return false;
        }

        var id = $ctrl.$ow.object.id;
        $ctrl.cards = [];

        if (!force && cache[id] !== void 0) {
            $ctrl.cards = cache[id];

            if (alertsCache[id] !== void 0) {
                $ctrl.alerts = alertsCache[id];
            }

            return;
        }

        $http
            .get('/api/node/object/driver-state?object=' + id)
            .then(
                function(response) {
                    var cards = response.data.data;
                    cache[id] = cards;
                    $ctrl.cards = cache[id];

                    applyAlertsOnCards(id);
                },
                function() {
                    $ctrl.cards = [];
                }
            )
            .then(function() {
                $ctrl.$ow.api.on.resize();
            });
    };

    var applyAlertsOnCards = function(id) {
        var alerts = ((($ctrl.$ow.object || {}).extended || {}).data || {}).tachographAlerts;

        alertsCache[id] = alerts;
        $ctrl.alerts = alertsCache[id];

        return true;
    }

    $ctrl.openAlertsModal = function() {
        var $isolated = $scope.$new(true);
        $isolated.data = $ctrl.alerts;

        $ngConfirm({
            title: $translate.instant('objects.alerts.header'),
            contentUrl: 'js/components/ow-cards/modals/alerts.html',
            animation: 'rotate',
            theme: 'supervan',
            columnClass: 'medium',
            icon: 'pe-7s-speaker pe-lg pe-va',
            scope: $isolated,
            buttons: {
                no: {
                    text: $translate.instant('general.confirm.save.cancel'),
                    btnClass: 'btn-dark',
                },
            },
        });
    };

    var getDrivers = function(force) {
        return $q(function(resolve, reject) {
            if (!force && $ctrl.drivers !== false) {
                return resolve($ctrl.drivers);
            }
            return $http.get('/api/driver').then(function(response) {
                $ctrl.drivers = response.data.data;
                return resolve($ctrl.drivers);
            }, reject);
        });
    };

    $ctrl.$onInit = function() {
        $ctrl.$ow.childs.push(this);
    };

    $ctrl.onObjectChanged = function() {
        $ctrl.cards = [];
        $ctrl.expands.cards = false;

        reload(false);
    };

    $ctrl.$onDestroy = function() {};

    var openModal = function() {
        $ngConfirm({
            title: $translate.instant('objects.cards.modal.driver'),
            contentUrl: 'js/components/ow-cards/modals/assign.html',
            animation: 'rotate',
            theme: 'supervan',
            columnClass: 'medium',
            icon: 'pe-7s-add-user pe-lg pe-va',
            scope: $scope,
            buttons: {
                yes: {
                    text: $translate.instant('general.confirm.save.ok'),
                    btnClass: 'btn-success',
                    action: function(scope) {
                        return onModalSubmit(scope);
                    },
                },
                no: {
                    text: $translate.instant('general.confirm.save.cancel'),
                    btnClass: 'btn-dark',
                },
            },
        });
    };

    var onModalSubmit = function(data) {
        var payload = {
            type: data.type,
            driver: data.driver,
            card: data.card,
        };

        $http.post('/api/driver/attachCard', payload).then(function() {
            reload(true);
        });
    };

    $ctrl.openDriverCardModal = function(type, no) {
        getDrivers(false).then(
            function(data) {
                $scope.choose = 1;
                $scope.type = type;
                $scope.card = no;
                $scope.driver = null;
                $scope.drivers = data;

                openModal();
            },
            function() {
                $ctrl.drivers = [];
            }
        );
    };

    $ctrl.openCreateDriverModal = function() {
        $scope.driver = null;
        $scope.form = {
            simple: true,
        };

        $ngConfirm({
            title: $translate.instant('drivers.form.header'),
            contentUrl: 'js/components/ow-cards/modals/driver.html',
            animation: 'rotate',
            theme: 'supervan',
            columnClass: 'medium',
            icon: 'pe-7s-add-user pe-lg pe-va',
            scope: $scope,
            buttons: {
                yes: {
                    text: $translate.instant('general.form.submit'),
                    btnClass: 'btn-success',
                    action: function(scope) {
                        return onCreateDriverModalSubmit(scope.form);
                    },
                },
                no: {
                    text: $translate.instant('general.confirm.save.cancel'),
                    btnClass: 'btn-dark',
                },
            },
        });
    };

    var onCreateDriverModalSubmit = function(payload) {
        $http.post('/api/driver/create', { new: payload, old: null }).then(
            function(response) {
                var id = response.data.data;
                selectCreatedDriver(id);
            },
            function() {
                toaster.pop(
                    'error',
                    $translate.instant('general.toastr.error.header'),
                    $translate.instant('general.toastr.error.form.action.save')
                );
            }
        );
        return true;
    };

    var selectCreatedDriver = function(id) {
        getDrivers(true).then(
            function(data) {
                $scope.choose = 2;
                $scope.drivers = data;

                $scope.driver = null;
                for (var i = 0; i < $scope.drivers.length; i++) {
                    var item = $scope.drivers[i];
                    if (item.driverId === id) {
                        $scope.driver = $scope.drivers[i].driverId;
                    }
                }
            },
            function() {
                $ctrl.drivers = [];
            }
        );
    };

    var loadDailyAnalyse = function(id, card) {
        var results = {
            data: false,
            analyze: {
                constantly: {
                    type: 'hours',
                },
                daily: {
                    type: 'hours',
                },
                moreThan9Hours: {
                    type: 'days',
                },
                weekly: {
                    type: 'hours',
                },
                twoWeeks: {
                    type: 'hours',
                },
                daysInWeek: {
                    type: 'days',
                },
            },
        };

        var date = moment().format('YYYY-MM-DD HH:mm:ss');
        var endpoint = '/api/object/' + id + '/analysis';

        var parameters = {
            date: date,
            single: 1,
        };
        if (card) {
            parameters.card = card;
        }

        return $http
            .get(endpoint, { params: parameters })
            .then(
                function(response) {
                    var data = response.data.data;
                    return data === void 0 ? [] : data;
                },
                function() {
                    return [];
                }
            )
            .then(function(data) {
                var summary = data.summary;

                var keys = Object.keys(summary);
                var types = ['now', 'max', 'left', 'rest'];

                for (var i = 0; i < keys.length; i++) {
                    var key = keys[i];
                    var item = summary[key];
                    var original = Object.assign({}, item);

                    original.percentage = Math.round((item.now / item.max) * 100);
                    original.percentage = original.percentage > 100 ? 100 : original.percentage;

                    results.analyze[key].original = original;

                    for (var j = 0; j < types.length; j++) {
                        var type = types[j];

                        if (item[type] === void 0) {
                            continue;
                        }

                        if (results.analyze[key].type === 'hours') {
                            var duration = moment.duration(item[type], 'seconds');
                            var hours = Math.floor(duration.asHours());
                            var mins = Math.floor(duration.asMinutes()) - hours * 60;

                            hours = hours < 10 ? '0' + String(hours) : hours;
                            mins = mins < 10 ? '0' + String(mins) : mins;

                            item[type] = hours + ':' + mins;
                        } else {
                            item[type] = item[type];
                        }
                    }
                    results.analyze[key] = Object.assign(results.analyze[key], item);
                }

                return results;
            });
    };
}
